import { resourcePath } from '@gameday/utils/resource-path';
import { getSafeLanguagePath } from '@gameday/utils/languageHelpers';
class PlayerStoryModel {
    constructor (data, params) {
        const {
            data: { playerStories }
        } = data;
        this.playerStories = {};
        playerStories.forEach((story, index) => {
            if (story.valid) {
                const { language, winnerIds } = params;
                const languagePath = getSafeLanguagePath(language);
                const playerId = winnerIds[index];
                const storyURL = resourcePath.get('playerStory', { playerId, languagePath });
                this.playerStories[playerId] = {
                    story: storyURL,
                    hasStory: true
                };
            }
        });
    }
}

export default PlayerStoryModel;
